export default "__VITE_ASSET__BWUFa8bs__"